import {select} from '@redux-saga/core/effects';
import selectors from 'features/layout/redux/selectors';
import qs from 'query-string';

export function* isDialogActive(dialogId: string) {
   const isActiveState = (yield select(selectors.isDialogActive, dialogId)) as ReturnType<
      typeof selectors.isDialogActive
   >;
   const parsedQuery = qs.parse(window.location.search);
   const isActiveHistory = parsedQuery?.dialog === dialogId;
   return isActiveState || isActiveHistory;
}
